export const CHART_TYPES = {
  LOW_HIGH: 'LOW_HIGH',
  SITES: 'SITES',
};

export const PLACEHOLDER_EXPORT = '';
